import { useState } from 'react'
import RinaContextCard from '../components/RinaContextCard'
import PageHub from '../components/PageHub'
import MarcheProducerStand from '../components/marche/MarcheProducerStand'
import { useActionsPortail } from '../contexts/navigation'
import { ROUTES } from '../routes'

/**
 * « Mon stand » — sous-page de l'onglet Évènements (/producteur/stand, S62).
 * Meme ecran que l'onglet du module plein ecran (`MarcheProducerStand`), sous
 * la barre du hub, avec un retour vers Évènements.
 */
function ContenuStandProducteur() {
  const { setHubTab } = useActionsPortail()
  const [flash, setFlash] = useState(null)
  const toast = (msg) => { setFlash(msg); setTimeout(() => setFlash(null), 2800) }
  return (
    <>
      {flash && (
        <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[200] px-4 py-2.5 rounded-xl text-sm font-medium shadow-lg animate-fade-up text-white" style={{ background: 'rgb(var(--c-green))' }}>
          {flash}
        </div>
      )}
      <RinaContextCard
        title="Mes produits par défaut"
        message="Ce que vous apportez d'habitude : activez ou coupez un produit, c'est la liste proposée à chaque inscription."
      />
      <MarcheProducerStand onGoOffers={() => setHubTab('offers')} onToast={toast} />
    </>
  )
}

export default function PageStandProducteur() {
  return (
    <PageHub retour={{ label: 'Évènements', vers: ROUTES.producteur.marches }}>
      <ContenuStandProducteur />
    </PageHub>
  )
}
